import React from 'react'

import {
  AlignItems,
  Box,
  Display,
  FlexDirection,
  FontWeight,
  Text,
} from '@gousto-internal/citrus-react'
import type { SimpleHeaderContentBlock } from '@library/api-menu-experience'

type SimpleHeaderProps = {
  contentBlock: SimpleHeaderContentBlock
}

export const SimpleHeader = ({ contentBlock }: SimpleHeaderProps) => {
  const title = contentBlock.title?.trim()
  const subtitle = contentBlock.subtitle?.trim()

  if (!title && !subtitle) {
    return null
  }

  return (
    <Box
      display={Display.Flex}
      flexDirection={[FlexDirection.Column, FlexDirection.Row]}
      alignItems={[AlignItems.FlexStart, AlignItems.Center]}
      gap={[0, 2]}
      paddingBottom={4}
    >
      {title ? <Text fontWeight={FontWeight.Bold}>{title}</Text> : null}
      {subtitle ? <Text size={[1, 4, 6]}>{subtitle}</Text> : null}
    </Box>
  )
}
